import { render } from "./PaymentPerformance.vue?vue&type=template&id=4855ba67&scoped=true"
import script from "./PaymentPerformance.vue?vue&type=script&lang=js"
export * from "./PaymentPerformance.vue?vue&type=script&lang=js"

import "./PaymentPerformance.vue?vue&type=style&index=0&id=4855ba67&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4855ba67"]])

export default __exports__